module.exports = __webpack_public_path__ + "img/Sophie.1c53b9c4.png";